var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "chain" }, [
    _c(
      "div",
      {
        staticClass: "chainItem",
        style:
          _vm.$store.getters.authUser.identityAuth > -1
            ? "margin: 0 auto;"
            : "margin: 0 auto;height: 90%"
      },
      [_vm._m(0), _vm._m(1)]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticStyle: { display: "flex", "align-items": "center" } },
      [
        _c("div", { staticClass: "black" }),
        _c("span", [_vm._v("保全链节点查询")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "it" }, [
        _c("p", [_vm._v("赣国仲裁委")]),
        _c(
          "a",
          { attrs: { href: "http://iacg.aihuz.com", target: "_blank" } },
          [_vm._v("点击查询")]
        )
      ]),
      _c("div", { staticClass: "it" }, [
        _c("p", [_vm._v("深汕仲裁委")]),
        _c(
          "a",
          { attrs: { href: "http://swzcw.aihuz.com", target: "_blank" } },
          [_vm._v("点击查询")]
        )
      ]),
      _c("div", { staticClass: "it" }, [
        _c("p", [_vm._v("十堰仲裁委")]),
        _c(
          "a",
          { attrs: { href: "http://syac.aihuz.com", target: "_blank" } },
          [_vm._v("点击查询")]
        )
      ]),
      _c("div", { staticClass: "it" }, [
        _c("p", [_vm._v("太原城南公证处")]),
        _c(
          "a",
          {
            attrs: {
              href: "http://cngzc.sfj.taiyuan.gov.cn/web/index.html#/chain",
              target: "_blank"
            }
          },
          [_vm._v("点击查询")]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62b703fe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62b703fe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/blockChain/securityChain.vue
// module id = xQ56
// module chunks = 2 3 6 8 15 16 18 19 20 21 22 25 37